let ordercenter = {
  path: 'ordercenter',
  name: 'ordercenter',
  redirect: '/ordercenter/list',
  component: () => import('@/views/ordercenter/index.vue'),
  meta: {
    name: '订单'
  },
  children: [
    {
      path: 'list',
      name: 'orderList',
      component: () => import('@/views/ordercenter/pages/list.vue'),
      meta: {
        name: '订单列表'
      }
    },
    {
      path: 'detail/:orderId',
      name: 'detail',
      component: () => import('@/views/ordercenter/pages/detail.vue'),
      meta: {
        name: '订单详情'
      }
    },
    {
      path: 'takeout',
      name: 'takeoutList',
      component: () => import('@/views/ordercenter/takeout/takeoutList.vue'),
      meta: {
        name: '商品订单'
      }
    },
    {
      path: 'takeoutDetail/:orderId',
      name: 'takeoutDetail',
      component: () => import('@/views/ordercenter/takeout/takeoutDetail.vue'),
      meta: {
        name: '商品订单详情'
      }
    },
    {
      path: 'washCare',
      name: 'washCareList',
      component: () => import('@/views/ordercenter/washCare/washCareList.vue'),
      meta: {
        name: '洗护订单'
      }
    },
    {
      path: 'washCareDetail/:orderId',
      name: 'washCareDetail',
      component: () => import('@/views/ordercenter/washCare/washCareDetail.vue'),
      meta: {
        name: '洗护订单详情'
      }
    },
    {
      path: 'evaluateRecovery',
      name: 'evaluateRecoveryList',
      component: () => import('@/views/ordercenter/evaluateRecovery/list.vue'),
      meta: {
        name: '估价订单'
      }
    },
    {
      path: 'evaluateRecoveryDetail/:id',
      name: 'evaluateRecoveryDetail',
      component: () => import('@/views/ordercenter/evaluateRecovery/detail.vue'),
      meta: {
        name: '估价订单详情'
      }
    },
    {
      path: 'recovery',
      name: 'recoveryList',
      component: () => import('@/views/ordercenter/recovery/list.vue'),
      meta: {
        name: '回收订单'
      }
    },
    {
      path: 'recoveryDetail/:id',
      name: 'recoveryDetail',
      component: () => import('@/views/ordercenter/recovery/detail.vue'),
      meta: {
        name: '回收订单详情'
      }
    },
    {
      path: 'housekeeping',
      name: 'housekeepingList',
      component: () => import('@/views/ordercenter/housekeeping/list.vue'),
      meta: {
        name: '家政订单'
      }
    },
    {
      path: 'housekeepingDetail/:id',
      name: 'housekeepingDetail',
      component: () => import('@/views/ordercenter/housekeeping/detail.vue'),
      meta: {
        name: '家政订单详情'
      }
    }
  ]
}
export default ordercenter;
